import React from 'react';
import styled from 'styled-components';
import { Stack } from '@grnhse/seedling/lib/birch/layouts/stack_v2';
import { SecondaryBody } from '@grnhse/seedling/lib/birch/typography';
import { FullPalette } from '@grnhse/seedling/lib/birch/colors';
import { format } from 'date-fns';
import { RediscoveryApplication } from 'talent_matching/talent_rediscovery/hooks/use_rediscovery_applications';
import { withLocalePrefix } from 'shared/utils/translation';

const t = withLocalePrefix(
  'talent_matching.rediscovery.table.application_history'
);

type LatestApplicationHistoryCellProps = {
  application: RediscoveryApplication;
  userDateFormat?: string;
};

const RejectedText = styled(SecondaryBody)`
  color: ${FullPalette.GRAY_800};
  font-size: 12px;
`;

const ReasonText = styled(SecondaryBody)`
  color: ${FullPalette.GRAY_700};
  font-size: 12px;
`;

const LatestApplicationHistoryCell = ({
  application,
  userDateFormat = 'month_day_year',
}: LatestApplicationHistoryCellProps) => {
  let dateFormat: string;
  switch (userDateFormat) {
    case 'day_month_year':
      dateFormat = 'd LLLL yyyy';
      break;
    case 'year_month_day':
      dateFormat = 'yyyy LLLL d';
      break;
    default:
      dateFormat = 'LLLL d, yyyy';
  }

  const formatDate = (date: string) => {
    return format(new Date(date), dateFormat);
  };

  return (
    <Stack spacing={0.5} sx={{ padding: 1, paddingLeft: 0 }}>
      <SecondaryBody medium>{application.hiringPlanName}</SecondaryBody>
      {application.rejectedOn && (
        <RejectedText>
          {t('rejected_on', { date: formatDate(application.rejectedOn) })}
        </RejectedText>
      )}
      {application.rejectionReason && (
        <ReasonText>
          {t('reason', { reason: application.rejectionReason })}
        </ReasonText>
      )}
      {application.currentStage && !application.rejectedOn && (
        <SecondaryBody style={{ fontSize: '12px' }}>
          {t('stage', { stage: application.currentStage.name })}
        </SecondaryBody>
      )}
    </Stack>
  );
};

export default LatestApplicationHistoryCell;
